<!-- This is an example of extending the DcPostGrid component so you can add your own post templates. Change the reference to DcPostGridResults to include the local one from your theme that you have modified. -->
<template>
	<div ref="postGrid" class="dc-post-grid-component-wrapper">
		<header class="dc-post-grid-header" slot="dc-post-grid-header">
			<div 
				v-if="title || subtitle" 
				class="dc-post-grid-top-left" 
				slot="dc-post-grid-top-left">
				<h2 v-if="title" class="section-title-default">{{ title }}</h2>
				<h3 v-if="subtitle" class="section-subtitle-default">{{ subtitle }}</h3>
			</div>
			<div 
				v-if="filters || search_form_placeholder" 
				class="dc-post-grid-top-right" 
				slot="dc-post-grid-top-right"
			>
				<a v-if="link && typeof link.url !== 'undefined'" 
					:href="link.url" 
					:target="link.target" 
					:class="link.class || ''"
				>
					{{ link.title }}
				</a>
				<Filters 
					v-if="currentPaged!==null" 
					:filterLabel="label_before_filters" 
					:filters="filters" 
					:initialModel="initial_model" 
					:currentPaged="currentPaged"
					:searchButtonId="searchButtonId"
					:searchFormPlaceholder="search_form_placeholder" 
					v-on:results="updateResults" 
					v-on:update-total-pages="updateTotalPages"
					v-on:update-current-paged="updateCurrentPaged"
					v-on:update-post-grid-min-height="updateMinHeight" 
				/>
			</div>
		</header>
		<div
			v-if="results" 
			:class="['dc-post-grid-results', 'uses-no-image-card-fallbacks', columnsClass]" 
			slot="dc-post-grid-results"
		>
			<DcPostGridResults 
				ref="resultsSection"
				:results="results" 
				:loading="loading" 
				:gridLayout="grid_layout" 
				:searchButtonId="searchButtonId"
				:showLoadMore="showLoadMore" 
				:currentPaged="currentPaged"
				:totalPages="totalPages"
				:endOfResults="endOfResults" 
				v-on:update-current-paged="updateCurrentPaged"
				v-on:load-more="loadMore"
			/>
		</div>
		<footer 
			class="dc-post-grid-footer"
			slot="dc-post-grid-footer"
		>
		</footer>
	</div>
</template>

<script>
import DcPostGrid from '@dc-post-grid/layout/DcPostGrid';
import DcPostGridResults from './DcPostGridResults';
import Filters from '@dc-post-grid/layout/Filters';
export default {
	extends: DcPostGrid,
	components: {
		DcPostGridResults,
		Filters
	}
}
</script>
